export const getComissionCreationObject = (data) => {
  let objectTemp = {
    name: data.name,
    jurisdiction_id: data.jurisdiction_id,
  };

  return objectTemp;
};

export const getComissionUpdatenObject = (data) => {
  let objectTemp = {
    name: data.name,
    jurisdiction_id: data.jurisdiction_id,
  };

  return objectTemp;
};
